<template>
    <dash
        icon="fa fa-dollar"
        titulo="PAGAMENTOS GESCON"
        subTitulo="APOIO"
        @click.native="$router.push({ name: 'Gescon_Apoios_Pagamentos' })"
        :qtd="qtd"
        :mostrarQtd="false"
        :loading="loading"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    props: {
        qtd: {
            type: Number
        },

        loading: {
            type: Boolean
        }
    },

    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>
